import * as React from "react";
const SvgFiBrandsCreativeCommonsRemix = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-creative-commons-remix_svg__a)">
      <path
        fill="#151A2D"
        d="M12.478 0q5.245 0 8.884 3.493Q25 6.964 25 12t-3.572 8.443Q17.656 24 12.478 24q-5.067 0-8.795-3.536Q0 16.929 0 12q0-4.907 3.683-8.507Q7.321 0 12.478 0m.044 2.164q-4.264 0-7.21 2.893Q2.256 8.036 2.255 12q0 4.007 3.036 6.9 3.036 2.914 7.232 2.914 4.173 0 7.277-2.936 2.947-2.742 2.947-6.879 0-4.114-2.99-6.943-2.97-2.891-7.234-2.892m8.393 10.157v3.386L17.522 17.1l-6.92-2.721-3.236 1.286-3.192-1.329V11.25l2.99-1.2-.022-.021V6.643l3.392-1.436 7.657 3.043v2.979zm-3.794 3.836v-2.198L11.36 11.7v2.186zm.379-2.786 2.01-.793-1.854-.75-1.964.793zm2.633 1.843v-2.079l-2.232.9v2.1z"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-creative-commons-remix_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsCreativeCommonsRemix;
